import { GoodProduct } from '../../../../graphql'
import { upc, year } from './hidden'
import partNumber from './partNumber'
import manufacturer from './manufacturer'
import description from './description'
import catClass from './catClass'
import category from './category'
import classification from './classification'
import listPrice from './listPrice'
import msrp from './msrp'
import getActions from './actions'

export default function getColumns(
	canEdit: boolean,
	openEditModal: ( part: GoodProduct ) => void,
) {
	return [
		partNumber,
		manufacturer,
		description,
		year,
		upc,
		catClass,
		category,
		classification,
		listPrice,
		msrp,
		getActions( canEdit, openEditModal ),
	]
}
